module.exports = __webpack_public_path__ + "static/media/bg-content.78121ecc.png";